export default __webpack_public_path__ + "static/1438-70cd9572a4a920011849856d0e88c63a.gif";